module.exports = __webpack_public_path__ + "img/hd-heart-icon.ae9799c8.svg";